import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';

export default function withMobile(WrappedComponent) {
  const mapPropsToState = (state) => ({
    isMobile: getIsMobile(state),
  });
  return connect(mapPropsToState)(WrappedComponent);
}
